import './Minibar.css';

export default function Minibar({ main_root, submenu_root, submenu_root2, systemtime }) {
    return (
        <div className="custom-bar print-disable stickyz" >
            <div className="custom-bar-wrapper">
                <div className="custom-bar-start d-none d-sm-block">
                    <h5>{main_root} <i className="mdi mdi-chevron-double-right"></i> {submenu_root}
                        {submenu_root2 !== undefined ? <> <i className="mdi mdi-chevron-double-right"></i> {submenu_root2}</> : null}</h5>

                </div>
                <div className="custom-bar-end">
                    <div className="timeboox">
                        <h5><i className="mdi mdi-clock-time-four-outline"></i> {systemtime}</h5>
                    </div>
                </div>
            </div>
        </div>
    )
}
